export default __webpack_public_path__ + "static/media/white-point-measure-icon.743d59fb.svg";